import {Component, OnInit, OnDestroy}        from '@angular/core';
declare var $: any;
import {EmpresaService} from '../empresa/empresa.service';
import {SucursalService} from '../sucursal/sucursal.service';
import {NodoService} from '../nodo/nodo.service';
import {MedicionService} from '../medicion/medicion.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {LoginService} from '../login/login.service';

import {Empresa} from '../empresa/empresa';
import {Sucursal} from '../sucursal/sucursal';
import {Nodo} from '../nodo/nodo';
import {Ubicacion} from '../ubicacion/ubicacion';
import {RegAlarma} from '../regAlarma/regAlarma';

import * as io from "socket.io-client";
import myGlobals = require('../config');

declare function escape(s: string): string;


var Highcharts = require('highcharts');

// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);
require('../../librerias/export-csv')(Highcharts);

var moment = require('moment');
import {DateTimeZonePipe} from '../pipes/dateTimeZonePipe';

var ChartGlobal;

@Component({
    selector: 'graficos',
    template: require('../../app/graficos/graficos.component.html'),
    styles: [require('../../app/graficos/graficos.component.css')],
    pipes: [DateTimeZonePipe]
})
export class GraficosComponent implements OnInit, OnDestroy {
    empresas: Empresa[];
    empresaSeleccionada: Empresa;
    sucursales: Sucursal[];
    sucursalSeleccionada: Sucursal;
    offsetTimeZone: string;
    ubicaciones: Ubicacion[];
    nodos: Nodo[];
    socket: any;
    ultimoColor: number;
    colors: Array<any>;
    regAlarma: RegAlarma[];
    regAlarmaNodos: RegAlarma[];
    abierto: any;
    ejeY: boolean;
    asignacionColor: any;
    //abierto:Boolean;
    noData: any;
    ultimaFecha: any;
    usuarioConectado: any;

    constructor(private empresaService: EmpresaService,
                private sucursalService: SucursalService,
                private nodoService: NodoService,
                private medicionService: MedicionService,
                private regAlarmaService: RegAlarmaService,
                private loginService: LoginService) {

    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.usuarioConectado = this.loginService.getDecodeToken();

        this.regAlarma = [];
        this.regAlarmaNodos = [];
        this.asignacionColor = new Map();
        this.abierto = true;
        this.ultimoColor = 0;
        this.ejeY = true;
        this.noData = true;
        this.ultimaFecha = new Map();
        this.ubicaciones = [];
        this.colors = ['#058DC7', '#50B432', '#ED561B', '#ae1316', '#8d02f7', '#64E572', '#FF9655', '#0da6a1', '#ff0000'];

        this.offsetTimeZone = "-03:00";

        //Conectar al socket con configuración específica
        this.socket = io.connect(myGlobals.default.URL_MQTT, { 
            path: myGlobals.default.PATH_MQTT,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });

        // Debug de conexiones
        this.socket.on('connect', () => {
            console.log('Socket gráficos conectado via:', this.socket.io.engine.transport.name);
            this.socket.io.engine.on('upgrade', () => {
                console.log('Socket gráficos actualizado a:', this.socket.io.engine.transport.name);
            });
        });

        //Obtener empresas de ese usuario
        this.empresaService.getEmpresas()
            .subscribe(
                data => {
                    this.empresas = data;
                    if (data.length > 0)
                        this.cambiarSucursales(data[0]._id);
                });

        Highcharts.setOptions({
            lang: {
                loading: 'Cargando...',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                exportButtonTitle: "Exportar",
                printButtonTitle: "Importar",
                rangeSelectorFrom: "Desde",
                rangeSelectorTo: "Hasta",
                rangeSelectorZoom: "Zoom",
                downloadPNG: 'Descargar imagen PNG',
                downloadJPEG: 'Descargar imagen JPEG',
                downloadPDF: 'Descargar imagen PDF',
                downloadSVG: 'Descargar imagen SVG',
                printChart: 'Imprimir',
                resetZoom: 'Reiniciar zoom',
                resetZoomTitle: 'Reiniciar zoom',
                thousandsSep: ",",
                decimalPoint: '.'
            }
        });

        ChartGlobal = Highcharts.chart('container', {
            chart: {
                type: 'spline',
                zoomType: 'xy',
                marginTop: 150,
            },
            lang: {noData: "Seleccione los datos que desea mostrar"},
            title: null,
            yAxis: {
                title: null,
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    millisecond: '%H:%M:%S.%L',
                    second: '%H:%M:%S',
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%e. %b',
                    week: '%e. %b',
                    month: '%b \'%y',
                    year: '%Y'
                },
                crosshair: true,
            },
            tooltip: {
                shared: true,
            },
            legend: {
                layout: 'vertical',
                align: 'left',
                x: 10,
                verticalAlign: 'top',
                y: 2,
                floating: true,
                backgroundColor: '#FFFFFF',
                maxHeight: 100,
            },
            credits: {
                enabled: false
            },
            exporting: {
                chart: {
                    marginBottom: 110,
                    // marginLeft: 80,
                    // width: 500
                },
                enabled: false,
                csv: {
                    dateFormat: '%d-%m-%Y %H:%M:%S'
                },
                chartOptions: {
                    marginBottom: 110,
                    title: {
                        text: "Gráficos",
                        style: {
                            fontSize: '26px'
                        }
                    },
                    subtitle: {
                        text: 'fecha'
                    },
                    xAxis: {
                        labels: {
                            style: {
                                fontSize: '16px'
                            }
                        },
                    },
                    legend: {
                        x:-135,
                        adjustChartSize: true,
                        align: 'right',
                        navigation: {
                            enabled: false
                        },
                        fontSize: '8px',
                        width: 100,
                        floating: true,
                        itemWidth: 60
                    },
                    yAxis: {
                        labels: {
                            style: {
                                fontSize: '26px'
                            }
                        }
                    }

                }
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 769
                    },
                    chartOptions: {
                        legend: {
                            y: 40,
                            maxHeight: 100
                        },
                        chart: {
                            marginTop: 200
                        }
                    }
                }]
            },
            events: {
                load: function(){
                    if (this.options.chart.forExport) {
                        Highcharts.each(this.series, function (series) {
                            series.yAxis.update({
                                labels: {
                                    style: {
                                        fontSize: 6
                                    }
                                }
                            });
                        });
                    }
                }
            }


        });
        setTimeout(function () {
            ChartGlobal.reflow();
        }, 300);

        if ($(window).width() < 769)
        //Ocultar la barra cuando hace click afuera
            $(document).bind("mouseup touchend", function (e) {
                var container = $("#barraSelectora");
                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0
                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
                    && e.target.id != "flechaBarraSelectora") // ... nor a descendant of the container
                {
                    $('#barraSelectora').css("display", "none");
                }
            });

    }

    ngOnDestroy() {
        this.socket.disconnect();
    }

    cambiarSucursales(id) {
        //Buscar empresa
        this.empresas.forEach(function (empresa) {
            if (empresa._id == id) {
                this.empresaSeleccionada = empresa;
                return
            }
        }.bind(this));

        //Vaciar grafico cuando cambio de variable
        this.noData = true;

        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    $("#" + sensor._id).attr('checked', false);
                    let e = {target: document.getElementById(sensor._id)};
                    this.graficar(e, sensor);
                }
            }
        }

        this.sucursalService.getSucursalByEmpresa(id).subscribe((data) => {
            this.sucursales = data;
            if (data.length > 0)
                this.cambiarSensores(data[0]._id);
            else {
                this.sucursales = [];
                this.ubicaciones = [];
            }
        });

    }

    cambiarSensores(id) {

        //Buscar sucursal
        this.sucursales.forEach(function (sucursal) {
            if (sucursal._id == id) {
                this.sucursalSeleccionada = sucursal;
                return
            }
        }.bind(this));

        //Vaciar grafico cuando cambio de variable
        this.noData = true;

        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    $("#" + sensor._id).attr('checked', false);
                    let e = {target: document.getElementById(sensor._id)};
                    this.graficar(e, sensor);
                }
            }
        }

        //Calcular offset huso horario
        this.sucursales.forEach(function (sucursal) {
            if (sucursal._id == id) {
                this.sucursalSeleccionada = sucursal;
                if(sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
                else
                    this.offsetTimeZone = "-03:00";
                return
            }
        }.bind(this));

        this.nodoService.getNodosBySucursal(id).subscribe((data) => {
                let i = 0;
                let ubicacionAnt = null;
                let nodo = null;
                this.nodos = data;
                var ubicacion = null;
                this.ubicaciones = [];
                while (i < this.nodos.length) {
                    nodo = this.nodos[i];
                    ubicacionAnt = nodo.ubicacion_id._id;
                    ubicacion = new Ubicacion();
                    ubicacion = nodo.ubicacion_id;
                    ubicacion.sensores = [];
                    while (i < this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
                        ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
                        i++;
                        nodo = this.nodos[i];
                    }
                    this.ubicaciones.push(ubicacion);
                }
            }
        );
    }

    graficar(e, sensor) {
        var chart = ChartGlobal;
        if (e.target.checked) {
            this.noData = false;
            setTimeout(function () {
                ChartGlobal.reflow();
            }, 100);
            this.medicionService.getMedicionesBySensor(sensor._id).subscribe(
                (data) => {
                    //Guardo puntos de la serie
                    let valores = [];
                    //Recorro las mediciones
                    for (let medicion of data) {
                        //Calculo fecha
                        //var str=medicion.fecha.toString().replace(".000Z","-0300");
                        var fechaMedicion = moment(medicion.fecha.toString()).utcOffset(this.offsetTimeZone);
                        var day = fechaMedicion.date();
                        var monthIndex = fechaMedicion.month();
                        var year = fechaMedicion.year();
                        var hour = fechaMedicion.hour();
                        var minutes = fechaMedicion.minutes();
                        var seconds = fechaMedicion.seconds();
                        //Calculo eje x
                        var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);
                        //Armo medicion
                        let nuevo = [];
                        nuevo.push(x);
                        nuevo.push(medicion.valor);
                        //Guardo medicion
                        valores.push(nuevo);
                    }
                    //Asignacion de color
                    let colorAsignado;
                    if (this.asignacionColor.get(sensor._id) == undefined) {
                        if (this.ultimoColor == this.colors.length)
                            this.ultimoColor = 0;
                        colorAsignado = this.colors[this.ultimoColor];
                        this.asignacionColor.set(sensor._id, colorAsignado);
                        this.ultimoColor++;
                    }
                    else {
                        colorAsignado = this.asignacionColor.get(sensor._id);
                    }

                    //Evaluo si el eje esta agregado
                    if (chart.get(sensor.tipo_id._id + "-ejeY") == null) {
                        //Agrego eje y
                        chart.addAxis({
                            id: sensor.tipo_id._id + "-ejeY",
                            labels: {
                                format: '{value}' + sensor.tipo_id.tipo,
                                style: {
                                    color: "black"
                                }
                            },
                            title: {
                                text: sensor.tipo_id.descripcion,
                                style: {
                                    color: "black"
                                }
                            },
                            //lineWidth: 2,
                            //lineColor: '#08F',
                            opposite: false,
                            //xAxis:1,
                            lineWidth: 1,
                            minorGridLineWidth: 0,
                            lineColor: "black",
                        });
                    }
                    //Agrego serie
                    chart.addSeries({
                        id: sensor._id + "-serie",
                        name: sensor.etiqueta,
                        type: 'line',
                        lineWidth: 2,
                        color: colorAsignado,
                        yAxis: sensor.tipo_id._id + "-ejeY",
                        data: valores,
                        tooltip: {
                            valueSuffix: ' ' + sensor.tipo_id.tipo
                        }
                    });

                    //Establecer socket

                    this.socket.on(sensor._id, function (data: any) {
                        //Busco la serie que corresponda
                        var series = chart.get(sensor._id + "-serie");

                        //Calculo fecha
                        //var str=data.fecha.toString().replace(".000Z","-0300");
                        var fechaMedicion = moment(data.fecha.toString()).utcOffset(this.offsetTimeZone);
                        //var date = new Date(data.fecha.toString());
                        var day = fechaMedicion.date();
                        var monthIndex = fechaMedicion.month();
                        var year = fechaMedicion.year();
                        var hour = fechaMedicion.hour();
                        var minutes = fechaMedicion.minutes();
                        var seconds = fechaMedicion.seconds();
                        var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);

                        //Controlo puntos
                        if (series.xData.length < 10)
                        //Agrego punto a la serie
                            series.addPoint([x, data.valor], true, false);
                        else
                        //Agrego punto a la serie
                            series.addPoint([x, data.valor], true, true);

                        //RecargoAlarmas
                        let borradoNodo = false;
                        let cantidadBorrados = 0;
                        for (let i = 0; i < this.regAlarma.length; i++) {
                            let alarma = this.regAlarma[i];
                            if ((alarma.sensor_id == null && cantidadBorrados > 0) || (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id)) {
                                var index = this.regAlarma.indexOf(alarma);
                                this.regAlarma.splice(index, 1);
                                i--;
                                cantidadBorrados++;
                            }
                        }
                        if (series.data.length > 0) {
                            //var d = new Date(series.data[0].x); // The 0 there is the key, which sets the date to the epoch
                            var d = new Date(1);
                            d.setUTCMilliseconds(series.data[0].x);

                            var tzoffset = (new Date().getTimezoneOffset() * 60000);
                            d = new Date(series.data[0].x + tzoffset); // The 0 there is the key, which sets the date to the epoch
                            this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, d.toISOString(), data.fecha)
                                .subscribe((regAlarmas) => {
                                    this.regAlarma.push.apply(this.regAlarma, regAlarmas);
                                })
                        }

                    }.bind(this));

                    //Obtengo alarmas
                    if (data.length > 0) {

                        //Alarmas Por Sensor
                        this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, data[0].fecha, data[data.length - 1].fecha, this.offsetTimeZone)
                            .subscribe((regAlarmas) => {
                                this.regAlarma.push.apply(this.regAlarma, regAlarmas);
                            })

                        //Alarmas Por nodo
                        let buscarAlarmasPorNodo = true;
                        for (let i = 0; i < this.regAlarmaNodos.length; i++) {
                            let alarma = this.regAlarmaNodos[i];
                            if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
                                buscarAlarmasPorNodo = false;
                                break;
                            }
                        }
                        if (buscarAlarmasPorNodo)
                            this.regAlarmaService.getRegAlarmasByNodoYFecha(sensor._id, data[0].fecha, data[data.length - 1].fecha, this.offsetTimeZone)
                                .subscribe((regAlarmas) => {
                                    this.regAlarmaNodos.push.apply(this.regAlarmaNodos, regAlarmas);
                                })
                    }
                }
            );
        }
        else {
            //Borrar eje y
            if (chart.get(sensor.tipo_id._id + "-ejeY").series.length == 1)
                chart.get(sensor.tipo_id._id + "-ejeY").remove();
            else
                chart.get(sensor._id + "-serie").remove();

            //Remover listener
            this.socket.removeAllListeners(sensor._id);

            //Borrar Alarmas por sensor
            for (let i = 0; i < this.regAlarma.length; i++) {
                let alarma = this.regAlarma[i];
                if (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id) {
                    var index = this.regAlarma.indexOf(alarma);
                    this.regAlarma.splice(index, 1);
                    i--;
                }
            }

            //Borrar Alarmas por nodo
            let borrarNodo = true;
            for (let ubicacion of this.ubicaciones) {
                for (let s of ubicacion.sensores) {
                    if ((<HTMLInputElement>document.getElementById(s._id)).checked) {
                        if (s.nodo_id == sensor.nodo_id) {
                            borrarNodo = false;
                        }
                    }
                }
            }
            if (borrarNodo) {
                for (let i = 0; i < this.regAlarmaNodos.length; i++) {
                    let alarma = this.regAlarmaNodos[i];
                    if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
                        var index = this.regAlarmaNodos.indexOf(alarma);
                        this.regAlarmaNodos.splice(index, 1);
                        i--;
                    }
                }
            }

            //Muestro cartel de sin datos
            if (chart.series.length == 0)
                this.noData = true;
            //Recargo grafico
            setTimeout(function () {
                ChartGlobal.reflow();
            }, 100);

        }

    }

    modificarBarra() {
        setTimeout(function () {
            ChartGlobal.reflow();
        }, 100);

    }

    ocultarEje() {
        //var chart = $('#container').highcharts();
        var chart = ChartGlobal;
        this.ejeY = !this.ejeY;
        for (let eje of chart.yAxis) {
            eje.update({
                visible: this.ejeY
            });
        }
    }

    export(tipo) {
        //var chart = $('#container').highcharts();
        var chart = ChartGlobal;
        var d = new Date();
        var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        chart.options.exporting.url = myGlobals.default.BASE_URL + '/informe/grafico';
        chart.options.exporting.chartOptions.title.text = this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion;
        chart.options.exporting.chartOptions.subtitle.text = datestring + " - " + this.usuarioConectado.nombre + " " + this.usuarioConectado.apellido;
        chart.options.exporting.chartOptions.subtitle.verticalAlign = 'bottom';
        chart.options.exporting.chartOptions.subtitle.align = 'left';
        chart.options.exporting.chartOptions.chart = {spacing: [20, 20, 60, 20]};
        chart.options.exporting.chartOptions.chart.marginTop = 230;
        chart.options.exporting.chartOptions.legend.y = 30;
        chart.options.exporting.chartOptions.legend.x = -700;
        chart.options.exporting.chartOptions.legend.maxHeight = 200;
        chart.options.exporting.chartOptions.legend.navigation = {enabled: false};
        // chart.options.exporting.chartOptions.yAxis.labels.style.fontSize = "30px";
        if(tipo == 'application/pdf'){
            chart.options.exporting.chartOptions.legend.itemStyle = {fontSize: '10px'};
            chart.options.exporting.sourceWidth = 842;
            chart.options.exporting.sourceHeight = 595;
            chart.options.exporting.scale = 0.2;
        }
        else {
            chart.options.exporting.chartOptions.legend.itemStyle = {fontSize: '12px'};
            chart.options.exporting.chartOptions.legend.x = -1000;
            chart.options.exporting.sourceWidth = 3508 / 3;
            chart.options.exporting.sourceHeight = 2480 / 3;
            chart.options.exporting.scale = 3;
            chart.options.exporting.chartOptions.legend.x = -1000;
        }

        chart.exportChart({
            type: tipo
        });
    }

    exportCSV() {
        var chart = ChartGlobal;
        const linkSource = `data:text/csv;charset=utf-8,${escape(chart.getCSV())}`;
        const downloadLink = document.createElement("a");
        const fileName = "datosSensoresTiempoReal" + ".csv";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    ocultarBarraSelectora() {
        if ($('#barraSelectora').css("display") == "block")
            $('#barraSelectora').css("display", "none");
        else
            $('#barraSelectora').css("display", "block");
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/graficos/graficos.component.ts